import request from '@/utils/request'


// 查询择医医师记录列表
export function listDoctor(query) {
  return request({
    url: '/user/doctor/list',
    method: 'get',
    params: query
  })
}

// 查询择医医师记录分页
export function pageDoctor(query) {
  return request({
    url: '/user/doctor/page',
    method: 'get',
    params: query
  })
}

// 查询择医医师记录详细
export function getDoctor(data) {
  return request({
    url: '/user/doctor/detail',
    method: 'get',
    params: data
  })
}

// 新增择医医师记录
export function addDoctor(data) {
  return request({
    url: '/user/doctor/add',
    method: 'post',
    data: data
  })
}

// 修改择医医师记录
export function updateDoctor(data) {
  return request({
    url: '/user/doctor/edit',
    method: 'post',
    data: data
  })
}

// 删除择医医师记录
export function delDoctor(data) {
  return request({
    url: '/user/doctor/delete',
    method: 'post',
    data: data
  })
}
